export default __webpack_public_path__ + "33d28d4abb68c0b6444442f8362d5cc1.png";